import { gsap } from 'gsap';

export function fadeInit(el, { x, y, scale } = { x: 0, y: 0, scale: 1 }) {
  gsap.set(el, {
    x,
    y,
    scale,
    autoAlpha: 0,
  });
}

export function fadeEnter(el, stagger = 0, duration = 1.2) {
  const tl = gsap.timeline();

  tl.addLabel('start')
    .to(el, {
      x: 0,
      y: 0,
      autoAlpha: 1,
      scale: 1,
      stagger,
      ease: 'power3.easeInOut',
      duration,
      clearProps: 'all',
    }, 'start');

  return tl;
}

export function fadeLeave(el, { x, y, scale } = { x: 0, y: 0, scale: 1 }, stagger = 0, duration = 1.2) {
  return gsap.to(el, {
    x,
    y,
    autoAlpha: 0,
    scale,
    stagger,
    ease: 'power3.easeOut',
    duration,
  });
}
